<template>
  <div class="sidebar">
    <WidgetsArea
      area="sidebar"
      container-widget-list="StickyList"
    />
  </div>
</template>

<script lang="ts">
  import WidgetsArea from '~/components/WidgetsArea/WidgetsArea.vue';

  export default defineNuxtComponent({
    name: 'TheSidebar',

    components: {
      WidgetsArea,
    },
  });
</script>
